import { render, staticRenderFns } from "./aflow.vue?vue&type=template&id=cda336a6&scoped=true&lang=pug&"
import script from "./aflow.vue?vue&type=script&lang=js&"
export * from "./aflow.vue?vue&type=script&lang=js&"
import style0 from "./aflow.vue?vue&type=style&index=0&id=cda336a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda336a6",
  null
  
)

export default component.exports